var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cf-container" },
    [
      _vm.hasDeliveryWindows
        ? _c(
            "md-table",
            [
              _c(
                "md-table-row",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("md-table-head", { staticClass: "time-range-columns" }, [
                    _vm._v("From"),
                  ]),
                  _c("md-table-head", { staticClass: "time-range-columns" }, [
                    _vm._v("To"),
                  ]),
                  _c("md-table-head", { staticClass: "max-stops-column" }, [
                    _vm._v("Max stops"),
                  ]),
                  _vm.hasCapacitySettings("volume")
                    ? _c(
                        "md-table-head",
                        { staticClass: "capacity-settings-columns" },
                        [_vm._v("\n                Max volume\n            ")]
                      )
                    : _vm._e(),
                  _vm.hasCapacitySettings("weight")
                    ? _c(
                        "md-table-head",
                        { staticClass: "capacity-settings-columns" },
                        [_vm._v("\n                Max weight\n            ")]
                      )
                    : _vm._e(),
                  _vm.hasCapacitySettings("quantity")
                    ? _c(
                        "md-table-head",
                        { staticClass: "capacity-settings-columns" },
                        [_vm._v("\n                Max quantity\n            ")]
                      )
                    : _vm._e(),
                  _c("md-table-head", { staticClass: "occurrence-column" }, [
                    _vm._v("Occurrence"),
                  ]),
                  _c(
                    "md-table-head",
                    { staticClass: "occurrence-date-column" },
                    [_vm._v("Occ. Start Date")]
                  ),
                  _c("md-table-head", { staticClass: "cut-off-label-column" }, [
                    _vm._v("Cut off"),
                  ]),
                  _c("md-table-head", [_vm._v("Actions")]),
                ],
                1
              ),
              _vm._l(_vm.filteredDeliveryWindows, function (deliveryWindow) {
                return _c(
                  "md-table-row",
                  { key: deliveryWindow.deliveryWindowId },
                  [
                    _c(
                      "md-table-cell",
                      { staticClass: "time-range-columns" },
                      [
                        _c(
                          "form-group",
                          [
                            _c("md-icon", [_vm._v("access_time")]),
                            _c("time-picker", {
                              attrs: {
                                time: deliveryWindow.startTime,
                                "all-time-options": false,
                                "is-required": true,
                                "data-testid": "deliveryWindow-startTime",
                              },
                              on: {
                                selectedTime: function (
                                  selectedTime,
                                  isTimeValid
                                ) {
                                  _vm.handleSetStartTime(
                                    selectedTime,
                                    isTimeValid,
                                    deliveryWindow
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "md-table-cell",
                      { staticClass: "time-range-columns" },
                      [
                        _c(
                          "form-group",
                          [
                            _c("md-icon", [_vm._v("access_time")]),
                            _c("time-picker", {
                              attrs: {
                                time: deliveryWindow.endTime,
                                "all-time-options": false,
                                "is-required": true,
                                "data-testid": "deliveryWindow-startTime",
                              },
                              on: {
                                selectedTime: function (
                                  selectedTime,
                                  isTimeValid
                                ) {
                                  _vm.handleSetEndTime(
                                    selectedTime,
                                    isTimeValid,
                                    deliveryWindow
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "md-table-cell",
                      { staticClass: "max-stops-column" },
                      [
                        _c(
                          "form-group",
                          [
                            _c("md-input", {
                              attrs: {
                                type: "number",
                                "data-testid": "deliveryWindow-maxStops",
                              },
                              model: {
                                value: deliveryWindow.maxStops,
                                callback: function ($$v) {
                                  _vm.$set(
                                    deliveryWindow,
                                    "maxStops",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "deliveryWindow.maxStops",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.hasCapacitySettings("volume")
                      ? _c(
                          "md-table-cell",
                          { staticClass: "capacity-settings-columns" },
                          [
                            _c(
                              "form-group",
                              [
                                _c("md-input", {
                                  attrs: {
                                    type: "number",
                                    "data-testid": "deliveryWindow-maxVolume",
                                  },
                                  model: {
                                    value: deliveryWindow.maxVolume,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        deliveryWindow,
                                        "maxVolume",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "deliveryWindow.maxVolume",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.hasCapacitySettings("weight")
                      ? _c(
                          "md-table-cell",
                          { staticClass: "capacity-settings-columns" },
                          [
                            _c(
                              "form-group",
                              [
                                _c("md-input", {
                                  attrs: {
                                    type: "number",
                                    "data-testid": "deliveryWindow-maxWeight",
                                  },
                                  model: {
                                    value: deliveryWindow.maxWeight,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        deliveryWindow,
                                        "maxWeight",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "deliveryWindow.maxWeight",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.hasCapacitySettings("quantity")
                      ? _c(
                          "md-table-cell",
                          { staticClass: "capacity-settings-columns" },
                          [
                            _c(
                              "form-group",
                              [
                                _c("md-input", {
                                  attrs: {
                                    type: "number",
                                    "data-testid": "deliveryWindow-maxQuantity",
                                  },
                                  model: {
                                    value: deliveryWindow.maxQuantity,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        deliveryWindow,
                                        "maxQuantity",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "deliveryWindow.maxQuantity",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "md-table-cell",
                      { staticClass: "occurrence-column" },
                      [
                        _c(
                          "form-group",
                          { staticClass: "delivery-window-dropdown" },
                          [
                            _c(
                              "md-select",
                              {
                                attrs: {
                                  "data-testid": "deliveryWindow-occurrence",
                                },
                                on: {
                                  "md-selected": function (id) {
                                    _vm.handleSetOcurrence(id, deliveryWindow)
                                  },
                                },
                                model: {
                                  value: deliveryWindow.occurrence,
                                  callback: function ($$v) {
                                    _vm.$set(deliveryWindow, "occurrence", $$v)
                                  },
                                  expression: "deliveryWindow.occurrence",
                                },
                              },
                              _vm._l(
                                _vm.deliveryWindowOccurrenceOptions,
                                function (option) {
                                  return _c(
                                    "md-option",
                                    {
                                      key: option.id,
                                      attrs: { value: option.id },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(option.name) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "md-table-cell",
                      { staticClass: "occurrence-date-column" },
                      [
                        deliveryWindow.occurrence === 1
                          ? _c("md-datepicker", {
                              attrs: {
                                "md-immediately": "",
                                "data-testid":
                                  "deliveryWindow-occurrenceStartDate",
                                "md-debounce": 100,
                                "md-disabled-dates": _vm.disableAllExcept,
                                "md-model-type": String,
                              },
                              model: {
                                value: deliveryWindow.occurrenceStartDate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    deliveryWindow,
                                    "occurrenceStartDate",
                                    $$v
                                  )
                                },
                                expression:
                                  "deliveryWindow.occurrenceStartDate",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "md-table-cell",
                      {
                        class:
                          "cut-off-label-column " +
                          (_vm.$_isValidServiceAreaCutOffCombination(
                            deliveryWindow,
                            _vm.dayOfTheWeek
                          )
                            ? ""
                            : "invalid-cutt-off-options"),
                      },
                      [
                        _c("md-icon", [_vm._v("access_time")]),
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$_generateServiceAreaCutOffLabel(
                                deliveryWindow,
                                _vm.dayOfTheWeek
                              )
                            ) +
                            "\n                "
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "edit-cutoff-button",
                            on: {
                              click: function () {
                                return _vm.handleEditCuttOff(
                                  deliveryWindow,
                                  _vm.dayOfTheWeek
                                )
                              },
                            },
                          },
                          [_c("md-icon", [_vm._v("arrow_drop_down")])],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "md-table-cell",
                      [
                        _c(
                          "md-button",
                          {
                            staticClass: "md-danger md-just-icon md-round",
                            attrs: { title: "Delete delivery window" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteDeliveryWindow(deliveryWindow)
                              },
                            },
                          },
                          [_c("md-icon", [_vm._v("delete")])],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          )
        : _vm._e(),
      !_vm.hasDeliveryWindows
        ? _c("div", { staticClass: "text-center" }, [
            _c("p", { staticClass: "no-result-message" }, [
              _vm._v("List is empty."),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "add-delivery-window-container" },
        [
          _c(
            "md-button",
            {
              staticClass: "md-button md-primary add-delivery-window-button",
              on: { click: _vm.handleAddDeliveryWindow },
            },
            [
              _c("md-icon", [_vm._v("add")]),
              _vm._v("\n            Add Delivery Window\n        "),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }